<script setup lang="ts">
import { computed, onBeforeMount, ref } from 'vue';
import { floatTimes, NumberCut } from '../../method/floatCalculate'
import { GetImgs, GetSImgs, SqlManipulate } from '../../method/Post';
import ls from '../../method/localStorage';
import { ElMessageBox } from 'element-plus';
const prop = defineProps<{
    langPack: Map<string, string>
    lang: string,
    orientation: string
}>();

let AllSelect = ref(false);
let modelValue = ref(new Array<any>)
let filterStr = ref("");
let previewList = ref(new Array<string>())
const ischange = ref(false)
onBeforeMount(() => {
    searchCart();
})



let ItemCount = computed(() => {
    if (modelValue.value) {
        return modelValue.value.filter(m => m.select).length;
    }
})

let TotalVolume = computed(() => {
    let result = 0;
    if (modelValue.value) {
        modelValue.value.forEach(item => {
            if (item.select) {
                result += Number.parseFloat(item.PVolume)
            }
        })
    }
    return Math.round(result * 1000) / 1000;
})

let TotalAmount = computed(() => {
    let result = 0;
    if (modelValue.value) {
        modelValue.value.forEach(item => {
            if (item.select) {
                result += Number.parseFloat(item.Amount)
            }
        })
    }
    return Math.round(result * 1000) / 1000;
})

//获取购物车信息
const searchCart = () => {
    SqlManipulate("Web_SearchCart", { TCustId: ls.get("CustId") }, (res: any) => {
        console.log(res)
        modelValue.value = res

        GetSImgs(modelValue.value);
        GetImgs(modelValue.value)
        SetSelect();
    })
}

const SetSelect = () => {
    modelValue.value.forEach(ele => {
        ele.select = true;
        ele.QtyPiece = Number.parseInt(ele.QtyPiece);
        ele.AuxQty = Number.parseInt(ele.AuxQty)
    })
}

const handleQtyChange = (item: any) => {
    ischange.value = true
    item.AuxQty = floatTimes(item.PWeight, item.QtyPiece);
    item.Amount = floatTimes(item.AuxQty, item.Price);
    item.PVolume = floatTimes(item.QtyPiece, item.Volume)

    setTimeout(() => {
        ischange.value = false
    }, 500);
}

const handleSubmit = () => {
    let data = new Array<any>();
    modelValue.value.filter(m => m.select).forEach(ele => {
        data.push({ Oid: ele.Oid, QtyPiece: ele.QtyPiece, AuxQty: ele.AuxQty, Amount: ele.Amount, PVolume: ele.PVolume, Note: ele.note == undefined ? "" : ele.note })
    })
    SqlManipulate("Web_SubmitCart", { data: JSON.stringify(data), TCustId: ls.get("CustId") }, (res: any) => {
        if (res.flag == 0) {
            ElMessageBox.alert(ref(prop.langPack).value.get("SubmitSuccess"), ref(prop.langPack).value.get("Success"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        } else {
            ElMessageBox.alert(res.msg, ref(prop.langPack).value.get("Error"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        }
        searchCart();
    })
}

const handleDelete = (oid?: number) => {
    let data = new Array<number>();
    if (oid) {
        data.push(oid);
    } else {
        modelValue.value.forEach(ele => {
            if (ele.select) {
                data.push(ele.Oid);
            }
        })
    }
    SqlManipulate("Web_DeleteCart", { Oid: JSON.stringify(data) }, (res: any) => {
        console.log(res)
        if (res.flag == 0) {
            ElMessageBox.alert(ref(prop.langPack).value.get("DeleteSuccess"), ref(prop.langPack).value.get("Success"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        } else {
            ElMessageBox.alert(res.msg, ref(prop.langPack).value.get("Error"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        }
        searchCart();
    })
}

const handleAllSelect = (e: any) => {
    if (e) {
        modelValue.value.forEach(item => {
            item.select = true;
        })
    } else {
        modelValue.value.forEach(item => {
            item.select = false;
        })
    }
}

const checkAllSelect = () => {
    if (AllSelect.value) {
        if (modelValue.value.findIndex(m => !m.select) > -1) {
            AllSelect.value = false;
        }
    } else {
        if (modelValue.value.findIndex(m => !m.select) == -1) {
            AllSelect.value = true
        }
    }
}

const handleFilter = () => {
    switch (ref(prop.lang).value) {
        case "简体中文":
            modelValue.value.sort((a, b) => { return b.Item_CN.includes(filterStr.value) - a.Item_CN.includes(filterStr.value) })
            break;
        case "English":
            modelValue.value.sort((a, b) => { return b.Item_EN.includes(filterStr.value) - a.Item_EN.includes(filterStr.value) })
            break;
        case "Español":
            modelValue.value.sort((a, b) => { return b.Item_ES.includes(filterStr.value) - a.Item_ES.includes(filterStr.value) })
            break;
        case "Português":
            modelValue.value.sort((a, b) => { return b.Item_ES.includes(filterStr.value) - a.Item_ES.includes(filterStr.value) })
            break;
    }
}
const handlePicClick = (URL: string) => {
    ischange.value = true
    previewList.value = [];
    previewList.value.push(URL)
    setTimeout(() => {
        ischange.value = false
    }, 500);
}

const handleRefresh = () => {
    searchCart();
}
const handleSave = () => {
    let data = new Array<any>();
    modelValue.value.filter(m => m.select).forEach(ele => {
        data.push({ Oid: ele.Oid, QtyPiece: ele.QtyPiece, AuxQty: ele.AuxQty, Amount: ele.Amount, PVolume: ele.PVolume, Note: ele.note == undefined ? "" : ele.note })
    })
    SqlManipulate("Web_Save", { data: JSON.stringify(data), TCustId: ls.get("CustId") }, (res: any) => {
        if (res.flag == 0) {
            ElMessageBox.alert(ref(prop.langPack).value.get("SaveSuccess"), ref(prop.langPack).value.get("Success"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        } else {
            ElMessageBox.alert(res.msg, ref(prop.langPack).value.get("Error"), {
                confirmButtonText: ref(prop.langPack).value.get("confirm")
            })
        }
        searchCart();
    })
}

const handleCardClick = (item: any) => {
    if (ischange.value) return;
    item.select = !item.select
}

const handleCardInput = () => {
    ischange.value = true
    setTimeout(() => {
        ischange.value = false
    }, 500);
}
</script>
<template>
    <div v-if="orientation == 'horizontal'">
        <el-card class="card">
            <el-row style="align-items: center;height: fit-content">
                <el-col :span="4">
                    <div class="leftIcon">
                        <el-checkbox v-model="AllSelect" :label="langPack.get('All')" size="large"
                            @change="handleAllSelect" />
                        <el-button type="danger" plain @click="handleDelete" style="margin-left: 10px;">
                            <el-icon>
                                <Delete />
                            </el-icon>
                            <text style="margin-left: 0.2rem;">{{ langPack.get("Delete") }}</text>
                        </el-button>
                    </div>
                </el-col>
                <el-col :span="5">
                    <div style="display: flex;flex-direction: row;justify-content: start;align-items: center;">
                        <text class="cardtitle">{{ langPack.get("productName") }}</text>
                        <el-input v-model="filterStr" @blur="handleFilter"
                            style="width: 10rem;margin-left: 0.5rem;"></el-input>
                    </div>
                </el-col>
                <el-col :span="3">
                    <text class="cardtitle">{{ langPack.get("QtyPiece") }}</text>
                </el-col>
                <el-col :span="3">
                    <text class="cardtitle">{{ langPack.get("AuxQty") }}</text>
                </el-col>
                <el-col :span="3">
                    <text class="cardtitle">{{ langPack.get("Volume") }}</text>
                </el-col>
                <el-col :span="3">
                    <text class="cardtitle">{{ langPack.get("Amount") }}</text>
                </el-col>
                <el-col :span="3">
                    <text class="cardtitle">{{ langPack.get("note") }}</text>
                </el-col>
            </el-row>
        </el-card>
        <div class="mainpart">
            <el-card v-for="item in modelValue" class="cartitem">
                <el-row style="align-items: center;height: fit-content">
                    <el-col :span="3">
                        <div class="leftIcon">
                            <el-checkbox v-model="item.select" size="large" @change="checkAllSelect" />
                            <el-image style="width:5rem;height:5rem;margin-left: 0.5rem" :src="item.IMG_1_S"
                                fit="contain" @click="handlePicClick(item.IMG_1)" :preview-teleported="true"
                                :preview-src-list="previewList" hide-on-click-modal></el-image>
                        </div>
                    </el-col>
                    <el-col :span="6">
                        <div
                            style="text-align: left;display: flex;flex-direction: column;height: 5rem;justify-content: space-between;">
                            <div style="display: flex;flex-direction: row;">
                                <text class="cardtitle" v-if="lang == '简体中文'">{{ item.Item_CN }}</text>
                                <text class="cardtitle" v-if="lang == 'English'">{{ item.Item_EN }}</text>
                                <text class="cardtitle" v-if="lang == 'Español'">{{ item.Item_ES }}</text>
                                <text class="cardtitle" v-if="lang == 'Português'">{{ item.Item_ES }}</text>
                                <text class="cardtitle" style="margin-left: 2rem;">{{ item.Pre }}</text>
                            </div>
                            <text class="cardtitle2">{{ langPack.get("PWeight") + ':' +
                                NumberCut(item.PWeight.toString())
                                }}</text>
                            <text class="cardtitle2">{{ langPack.get("Volume") + ':' + NumberCut(item.Volume.toString())
                                +
                                'm³'
                            }}</text>
                            <text class="cardtitle2">{{ langPack.get("Price") + ":$" + NumberCut(item.Price.toString())
                                }}</text>
                            <text class="cardtitle" v-if="lang == '简体中文'">{{ item.Char_MS_CN }}</text>
                            <text class="cardtitle" v-if="lang == 'English'">{{ item.Char_MS_EN }}</text>
                            <text class="cardtitle" v-if="lang == 'Español'">{{ item.Char_MS_ES }}</text>
                            <text class="cardtitle" v-if="lang == 'Português'">{{ item.Char_MS_ES }}</text>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <div style="display: flex;flex-direction: column;justify-content: center;align-items: center;">
                            <el-input-number v-model="item.QtyPiece"
                                :min="item.LWeight == undefined ? 1 : Math.max(1, item.LWeight)" step-strictly :step="1"
                                @change="handleQtyChange(item)" />
                            <text class="warningtext"
                                v-if="item.QtyPiece == (item.LWeight == undefined ? 1 : Math.max(1, item.LWeight))">*{{
                                    langPack.get("LWeightis") }}
                                {{ item.LWeight == undefined ? 1 : Math.max(1, item.LWeight) }}</text>
                        </div>
                    </el-col>
                    <el-col :span="3">
                        <text style="color: #409eff;font-size: 0.7rem;">{{
                            NumberCut(item.AuxQty.toString()) }}</text>
                    </el-col>
                    <el-col :span="3">
                        <text style="color: #409eff;font-size: 0.7rem;">{{ NumberCut(item.PVolume.toString())
                            }}m³</text>
                    </el-col>
                    <el-col :span="3">
                        <text style="color: #409eff;font-size: 0.7rem;">${{ NumberCut(item.Amount.toString()) }}</text>
                    </el-col>
                    <el-col :span="3">
                        <el-input v-model="item.note" style="width:10rem" :rows="3" type="textarea"
                            :placeholder="langPack.get('PleaseInput')" />
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div class="cartfooter">
            <el-button type="success" plain style="height: 1.8rem;width: 1.8rem;font-size: 1.8rem;"
                @click="handleRefresh">
                <el-icon>
                    <RefreshRight />
                </el-icon></el-button>
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("ItemCount") }}:</text>
                <text style="color:#409eff;font-size: 1.8rem;">{{ ItemCount }}</text>
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("TotalVolume") }}:</text>
                <text style="color:#409eff;font-size: 1.8rem;">{{ TotalVolume }}</text>
                <text>m³</text>
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("TotalAmount") }}:</text>
                <text style="color:#409eff;font-size: 1.8rem;">{{ TotalAmount }}</text>
                <text>$</text>
            </div>
            <el-button type="warning" style="height: 2rem;width: 6rem;font-size: 1rem;" @click="handleSave">
                {{ langPack.get("Save") }}</el-button>
            <el-button type="primary" style="height: 2rem;width: 8rem;font-size: 1rem;" @click="handleSubmit">
                {{ langPack.get("SubmitOrder") }}</el-button>

        </div>
    </div>

    <div v-if="orientation == 'vertical'">
        <div class="mainpart-vertical">
            <el-card v-for="item in modelValue" class="cartitem-vertical"
                :style="{ background: item.select == true ? '#3cf0f3' : '#ffffff' }" @click="handleCardClick(item)">
                <el-button class="cardbutton-delete" type="danger" size="mini"
                    @click="handleDelete(item.Oid)">删除</el-button>
                <el-row style="align-items: center;height: fit-content">
                    <el-col :span="9">
                        <div class="leftIcon">
                            <el-image style="width:160px;height:160px;" :src="item.IMG_1_S" fit="contain"
                                @click="handlePicClick(item.IMG_1)" :preview-teleported="true"
                                :preview-src-list="previewList" hide-on-click-modal></el-image>
                        </div>
                    </el-col>
                    <el-col :span="15">
                        <div style="text-align: left;display: flex;flex-direction: column;height: fit-content;">
                            <div style="display: flex;flex-direction: row;">
                                <text class="cardtitle-vertical" v-if="lang == '简体中文'">{{ item.Item_CN }}</text>
                                <text class="cardtitle-vertical" v-if="lang == 'English'">{{ item.Item_EN }}</text>
                                <text class="cardtitle-vertical" v-if="lang == 'Español'">{{ item.Item_ES }}</text>
                                <text class="cardtitle-vertical" v-if="lang == 'Português'">{{ item.Item_ES }}</text>
                                <text class="cardtitle-vertical" style="margin-left: 2rem;">{{ item.Pre }}</text>
                            </div>
                            <div style="display: flex;flex-direction: row;">
                                <text class="cardtitle2-vertical">{{ langPack.get("PWeight") + ':' +
                                    NumberCut(item.PWeight.toString())
                                    }}</text>
                                <text class="cardtitle2-vertical">{{ langPack.get("Volume") + ':' +
                                    NumberCut(item.Volume.toString())
                                    +
                                    'm³'
                                }}</text>
                                <text class="cardtitle2-vertical">{{ langPack.get("Price") + ":$" +
                                    NumberCut(item.Price.toString())
                                    }}</text>
                            </div>
                            <text class="cardtitle-vertical" v-if="lang == '简体中文'">{{ item.Char_MS_CN }}</text>
                            <text class="cardtitle-vertical" v-if="lang == 'English'">{{ item.Char_MS_EN }}</text>
                            <text class="cardtitle-vertical" v-if="lang == 'Español'">{{ item.Char_MS_ES }}</text>
                            <text class="cardtitle-vertical" v-if="lang == 'Português'">{{ item.Char_MS_ES }}</text>
                            <div>
                                <text class="cardtitle-vertical">{{ langPack.get("QtyPiece") }}</text>
                                <el-input-number v-model="item.QtyPiece" width="40"
                                    :min="item.LWeight == undefined ? 1 : Math.max(1, item.LWeight)" step-strictly
                                    :step="1" @change="handleQtyChange(item)" />
                            </div>
                            <text class="warningtext-vertical"
                                v-if="item.QtyPiece == (item.LWeight == undefined ? 1 : Math.max(1, item.LWeight))">*{{
                                    langPack.get("LWeightis") }}
                                {{ item.LWeight == undefined ? 1 : Math.max(1, item.LWeight) }}</text>
                            <div style="display: flex;flex-direction: row;">
                                <div>
                                    <text class="cardtitle-vertical">{{ langPack.get("AuxQty") + ':' }}</text>
                                    <text style="color: #409eff;font-size: 14px;margin-right: 5px;">{{
                                        NumberCut(item.AuxQty.toString()) }}</text>
                                </div>
                                <div>
                                    <text class="cardtitle-vertical">{{ langPack.get("Volume") + ':' }}</text>
                                    <text style="color: #409eff;font-size: 14px;margin-right: 5px;">{{
                                        NumberCut(item.PVolume.toString())
                                        }}m³</text>
                                </div>
                            </div>
                            <div>
                                <text class="cardtitle-vertical">{{ langPack.get("Amount") + ':' }}</text>
                                <text style="color: #409eff;font-size:14px;">${{ NumberCut(item.Amount.toString())
                                    }}</text>
                            </div>
                            <div style="display: flex;flex-direction: row;align-items: flex-start;">
                                <text class="cardtitle-vertical">{{ langPack.get("note") + ':' }}</text>
                                <el-input v-model="item.note" style="width:160px" :rows="2" type="textarea"
                                    :placeholder="langPack.get('PleaseInput')" @focus="handleCardInput" />
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </el-card>
        </div>
        <div class="cartfooter-vertical">
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("ItemCount") }}:</text>
                <text style="color:#409eff;font-size: 18px;">{{ ItemCount }}</text>
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("TotalVolume") }}:</text>
                <text style="color:#409eff;font-size: 18px">{{ TotalVolume }}</text>
                <text>m³</text>
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;">
                <text>{{ langPack.get("TotalAmount") }}:</text>
                <text style="color:#409eff;font-size:18px">{{ TotalAmount }}</text>
                <text>$</text>
            </div>
            <el-button type="warning" style="height:30px;width: 60px;font-size:10px;" @click="handleSave">
                {{ langPack.get("Save") }}</el-button>
            <el-button type="primary" style="height:30px;width: 60px;font-size:10px;" @click="handleSubmit">
                {{ langPack.get("SubmitOrder") }}</el-button>
        </div>
    </div>
</template>
<style scoped>
.card {
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    height: fit-content;
    padding: 0;
}

.cardtitle {
    font-size: 0.7rem;
    color: #333333;
}

.cardtitle-vertical {
    font-size: 16px;
    color: #333333;
}

.cardtitle2 {
    font-size: 0.6rem;
    color: #333333;
}

.cardtitle2-vertical {
    font-size: 12px;
    color: #333333;
    margin-right: 5px;
}

.leftIcon {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: fit-content;
    padding: 0;
    font-size: 0.7rem;
}

.mainpart {
    margin: 0.2rem 0.8rem 0 0.8rem;
    padding: 0 0 1rem 0;
    height: 62vh;
    overflow-y: scroll;
}

.mainpart-vertical {
    margin: 0;
    padding: 0 5px 0 5px;
    height:  calc(var(--vh, 1vh) * 100 - 160px);
    overflow-y: scroll;
}


.cartitem {
    margin-top: 0.5rem;
}

.cartitem-vertical {
    margin: 5px;
    padding: 0;
    border-radius: 15px;
    position: relative;
}

.cardbutton-delete {
    position: absolute;
    right: 0px;
    top: 0px;
}

.warningtext {
    color: red;
    font-size: 0.6rem;
}

.warningtext-vertical {
    color: red;
    font-size: 12px;
}

.cartfooter {
    width: 100%;
    padding: 0;
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    height: 8vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 1rem;
    color: #333333;
    justify-content: space-around;
}


.cartfooter-vertical {
    border-top: 1px solid silver;
    padding: 0;
    margin-left: 0.8rem;
    margin-right: 0.8rem;
    height: 40px;
    display: flex;
    flex-direction: row;
    align-items: center;
    font-size: 14px;
    color: #333333;
    justify-content: space-around;
}
</style>